import Image from '@/components/UI/Image';
import shopifyBtn from '@/constants/crowdfunding';
import { getInitInventory } from '@/service/crowdfunding';
import { getSolarRecommand } from '@/service/solar-calculator';
import { FormatMoney, getHostApi } from '@/utils';
import { getWSSUrl } from '@/utils/countryRegion';
import wss from '@/utils/mqtt-client';
import topics from '@/utils/mqtt-client/crowd-funding-topics';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { memo } from 'react';
import css from './index.module.scss';
import { saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

export const ShopifyBuyBtn = ({ productId, variantId, node, text, activeTab, data, shopifyBtnProps }: any) => {
    const { useEffect, gtm, useRouter, useLang } = useGlobal();
    const { productName, price, tag, quantity, button_name } = data;
    const { locale } = useRouter();
    const { t } = useLang('shared');

    // shopify 点击checkout事件埋点
    const onCheckoutBtnClick = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_checkout',
            type: 'none',
            button_name: 'checkout',
        });
    };

    // shopify埋点事件
    const onBuyBtnClick = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                list_name: 'none',
                event_name: 'bundle_add_to_cart',
                product_name: productName,
                price,
                tag: tag || 'none',
                quantity,
                button_name,
            });
            window?.fbq && window?.fbq('track', 'AddToCart');
        } catch (e) {
            console.error(e);
        }
    };

    // 点击购买埋点
    const afterRenderCallback = () => {
        const shopCarContainer: any = document.querySelector('.shopify-buy-frame.is-active');

        if (shopCarContainer && activeTab === 'bundles') {
            shopCarContainer.style.display = 'block';
        } else if (shopCarContainer && activeTab !== 'bundles') {
            shopCarContainer.style.display = 'none';
        }

        const iframeNode: any = document.querySelector(`#${node} > iframe`)?.contentWindow;
        const buyBtn = iframeNode.document.querySelector('.shopify-buy__btn');

        if (buyBtn) {
            buyBtn.addEventListener('click', onBuyBtnClick);
        }
    };

    // 购物车的埋点功能
    const afterCartRenderCallback = (bundleList: any) => {
        const checkoutNode = document.querySelector('[name="frame-cart"]')?.contentWindow;
        const checkoutBtn = checkoutNode.document.querySelector('[data-element="cart.button"]');
        const addBtn = checkoutNode.document.querySelectorAll('[data-element="lineItem.quantityIncrement"]');
        const decreaseBtn = checkoutNode.document.querySelectorAll('[data-element="lineItem.quantityDecrement"]');

        if (checkoutBtn) {
            checkoutBtn.onclick = onCheckoutBtnClick;
        }

        if (addBtn.length) {
            for (let index = 0; index < addBtn.length; index++) {
                const dom = addBtn[index] as HTMLButtonElement;
                dom.onclick = function (e: any) {
                    const itemContainer = e.srcElement.parentNode.parentNode.parentNode;
                    const productN = itemContainer.querySelector('[data-element="lineItem.itemTitle"]')?.innerHTML || '';
                    const price = itemContainer.querySelector('.shopify-buy__cart-item__price')?.innerHTML;
                    const quantity = itemContainer.querySelector('[data-element="lineItem.quantityInput"]');
                    const product = bundleList.find((item: any) => item.name === productN);
                    const tag =
                        product?.tag === 1
                            ? t('crowdfunding.bundles.supper_early')
                            : product?.tag === 2
                            ? t('crowdfunding.bundles.supper_tag')
                            : product?.tag === 3
                            ? t('crowdfunding.bundles.pre_order')
                            : product?.tag === 4
                            ? t('crowdfunding.bundles.new_arrival')
                            : typeof product?.tag === 'string'
                            ? product?.tag
                            : t('crowdfunding.bundles.order') || '';

                    gtm.push({
                        event: 'uaEvent',
                        list_name: 'none',
                        event_name: 'bundle_add_to_cart',
                        product_name: productN,
                        price: price ? Number(price.substr(1).replaceAll(',', '')) : '',
                        tag: tag || 'none',
                        quantity: `${parseInt(quantity.value, 10) + 1}`,
                        button_name: 'add',
                    });
                };
            }
        }

        if (decreaseBtn.length) {
            for (let index = 0; index < decreaseBtn.length; index++) {
                const dom = decreaseBtn[index] as HTMLButtonElement;
                dom.onclick = function (e: any) {
                    const itemContainer = e.srcElement.parentNode.parentNode.parentNode;
                    const productN = itemContainer.querySelector('[data-element="lineItem.itemTitle"]')?.innerHTML || '';
                    const price = itemContainer.querySelector('.shopify-buy__cart-item__price')?.innerHTML;
                    const quantity = itemContainer.querySelector('[data-element="lineItem.quantityInput"]');

                    const product = bundleList.find((item: any) => item.name === productN);
                    const tag =
                        product?.tag === 1
                            ? t('crowdfunding.bundles.supper_early')
                            : product?.tag === 2
                            ? t('crowdfunding.bundles.supper_tag')
                            : product?.tag === 3
                            ? t('crowdfunding.bundles.pre_order')
                            : product?.tag === 4
                            ? t('crowdfunding.bundles.new_arrival')
                            : typeof product?.tag === 'string'
                            ? product?.tag
                            : t('crowdfunding.bundles.order') || '';

                    gtm.push({
                        event: 'uaEvent',
                        list_name: 'none',
                        event_name: 'bundle_remove_from_cart',
                        product_name: productN,
                        price: price ? Number(price.substr(1).replaceAll(',', '')) : '',
                        tag: tag || 'none',
                        quantity: `${parseInt(quantity.value, 10) - 1}`,
                        button_name: 'remove',
                    });
                };
            }
        }
    };

    useEffect(() => {
        const mountedNode = document.querySelector(`#${node}`);

        // 条件： 是否在bundles页，并且是否已经渲染（已经渲染存在子节点内容）
        if (activeTab === 'bundles') {
            if (mountedNode?.innerHTML) mountedNode.innerHTML = '';
            shopifyBtn({
                id: productId,
                variantId,
                node,
                text,
                afterRenderCallback,
                afterCartRenderCallback,
                locale,
                bundleList: data.bundleList,
                shopifyBtnProps,
            });
        }

        return () => {
            const iframeNode: any = document.querySelector(`#${node} > iframe`)?.contentWindow;
            const buyBtn = iframeNode?.document?.querySelector('.shopify-buy__btn');
            const checkoutNode = document.querySelector('[name="frame-cart"]')?.contentWindow;
            const checkoutBtn = checkoutNode?.document?.querySelector('[data-element="cart.button"]');
            // .contentWindow.querySelector('[data-element="cart.button"]')

            if (buyBtn) {
                buyBtn?.removeEventListener('click', onBuyBtnClick);
            }
            if (checkoutBtn) {
                checkoutBtn?.removeEventListener('click', onCheckoutBtnClick);
            }
        };
    }, [activeTab, productId]);

    return (
        <>
            <div id={node}></div>
        </>
    );
};

const Child = ({
    bundlesData,
    activeTab,
    webpUrl,
    nowSysTime,
    crowdfundingTimeline = { stage1: 0, stage2: 0, end: 0 },
    shopifyBtnProps = null,
    activityId,
    callbackSubtitle,
    callbackDays,
    days,
    topCountdown,
    callbackCountdown,
    getShopifyPrice,
}: any) => {
    const { useLang, Link, useState, useEffect, useRouter, useRef, getSystemTime, gtm } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const { EFPic } = createEFPic(webpUrl);
    const { stage1, stage2, end } = crowdfundingTimeline;
    const [currList, setCurrList] = useState(bundlesData);
    const subscribes = ['inventory'];
    const url = String(getWSSUrl(locale));
    const { receiver, mqttUnsubscribe, mqttSubscribe } = wss({
        url,
        topics,
        locale,
        subscribes,
        activityId,
    });

    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    // 计时器
    const timer: any = useRef(null);

    // 日期倒计时
    const [countdownDateObj, setCountdownDateObj] = useState({ d: 0, h: 0, m: 0, s: 0 });

    // 货币分隔符
    const MONEY_SPLITER: string = ['eu', 'de', 'fr', 'it', 'es'].includes(locale) ? '.' : ',';

    // 除了de/fr/it/es货币符号在后， 其余站（含eu\uk)货币符号在前
    const MONEY_SORT: boolean = ['de', 'fr', 'it', 'es'].includes(locale);

    // 是否存在有倒计时的展示
    const HAS_COUNTDOWN: boolean = bundlesData?.some((bundle: any) => bundle?.countdown) || topCountdown;

    // 更新mqtt发送数据
    const updateBundles = (data: any) => {
        const resultArr: any = [];
        const tempList = JSON.parse(JSON.stringify(bundlesData));
        tempList.forEach((item: any) => {
            // 早鸟有折扣产品
            const targetIndex = data?.findIndex(
                (list: any) =>
                    item.id === list?.productId && (item?.stage === 1 || item?.count) && (item?.variantId ? item?.variantId === list?.variantId : true),
            );

            if (targetIndex !== -1 && Array.isArray(data)) {
                const targetData = data[targetIndex];
                if (targetData?.inventory > 0 || (item?.type === 3 && item?.stage === 2)) {
                    item.inventory = targetData.inventory;
                    item.sku = targetData?.sku;
                    item.variantId = targetData?.variantId;
                    if (targetData?.compareAtPrice >= 0) {
                        item.originalPrice = targetData?.compareAtPrice;
                    }
                    if (targetData?.price >= 0) {
                        item.discountPrice = targetData?.price;
                    }
                    resultArr.push(item);
                } else {
                    const targetBundle = tempList[targetIndex + 1];
                    resultArr.push(targetBundle);
                }
            }
        });
        setCurrList(resultArr);
    };

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTimeStamp.current = getSystemTime();
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }
        }
    };

    const calDays = (end: any) => {
        const days: number = Math.floor((end - nowSysTime) / 1000 / 3600 / 24);
        return days > 0 ? days : 0;
    };

    const hanldleData = () => {
        // if (serverTimeStamp.current > end && end !== 0) {
        //     // 详情页
        //     return currList?.length !== 0 && setCurrList([]);
        // }
        if (serverTimeStamp.current >= stage2 && stage2 !== 0) {
            const resultArr = bundlesData?.filter((item: any) => (item?.ignore || item?.needSlodout) && item?.stage === 2);
            const withShopifyPriceArr = syncShopifyPrice(resultArr);
            JSON.stringify(resultArr) !== JSON.stringify(currList) && setCurrList(withShopifyPriceArr);
            const newCalDays = calDays(end);
            days !== newCalDays && callbackDays(newCalDays);
            return callbackSubtitle('');
        }
        if (serverTimeStamp.current >= stage1 && stage1 !== 0) {
            const resultArr = bundlesData?.filter(
                (item: any) => ((item?.ignore || item?.needSlodout) && item?.stage === 1 && item.type === 1) || item.type === 3,
            );
            const withShopifyPriceArr = syncShopifyPrice(resultArr);
            JSON.stringify(resultArr) !== JSON.stringify(currList) && setCurrList(withShopifyPriceArr);
            const newCalDays = calDays(stage2 !== 0 ? stage2 : end);
            days !== newCalDays && callbackDays(newCalDays);
            const flag = bundlesData.some((itemx: any) => itemx.stage === 1) && bundlesData.some((itemx: any) => itemx.stage === 2);
            return flag && callbackSubtitle(t('crowdfunding.header.subTitle'));
        }
        if (serverTimeStamp.current < stage1) {
            // 预热页
            return currList?.length !== 0 && setCurrList([]);
        }
    };

    const formatCountdownDate = (now: number) => {
        const format = (time: number) => {
            const ts = Math.floor(time / 1000);
            const d = String(Math.floor(ts / 3600 / 24)).padStart(2, '0');
            const h = String(Math.floor((ts / 3600) % 24)).padStart(2, '0');
            const m = String(Math.floor((ts / 60) % 60)).padStart(2, '0');
            const s = String(Math.floor(ts % 60)).padStart(2, '0');
            if (HAS_COUNTDOWN) {
                setCountdownDateObj({ d, h, m, s });
                if (topCountdown) callbackCountdown({ d, h, m, s });
            }
        };
        if (stage2 !== 0) {
            // 暂未用到，作为可能备用 => jp
            if (now >= stage1 && stage1 !== 0 && now < stage2) {
                format(stage2 - now);
            }
            if (now >= stage2 && stage2 !== 0 && now < end) {
                format(end - now);
            }
        } else {
            format(end - now);
        }
    };

    const syncShopifyPrice = (data: any) => {
        const tempArr = JSON.parse(JSON.stringify([...data]));
        if (getShopifyPrice) {
            const getAsynItem = async (productId: string, variantId: string, k: number) => {
                return await new Promise(async (resolve, reject) => {
                    try {
                        const res = await getSolarRecommand({ productId, variantId }, locale);
                        if (res?.code === '0') {
                            tempArr[k].discountPrice = res?.data?.price || tempArr[k].discountPrice;
                            tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price || tempArr[k].originalPrice;
                            tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                            // tempArr[k].inventory = 1;
                            tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                            return resolve(res);
                        } else {
                            console.error(res?.message);
                            return reject(res?.message);
                        }
                    } catch (e) {
                        console.error(e);
                        return reject(e);
                    }
                });
            };
            const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId || item?.id, item.variantId, k));
            Promise.all(promises)
                .then(() => {
                    // setCurrList(tempArr?.filter((list: any) => list?.inventory !== undefined));
                    // return tempArr;
                })
                .catch((e) => {
                    console.error(e);
                });
        }
        return tempArr;
    };

    const handleToShopify = (link?: string) => {
        if (link) {
            window.open(link, '_blank');
        }
    };

    const handleLinkClick = (bundle: any) => {
        saveAICookieForShopify(`https://${locale}.ecoflow.com/cart/${bundle.variantId}:1?channel=buy_button`, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${t('crowdfunding.bundles.buy')}_${bundle.name}`,
        });
    };
    // 初始化: 获取实时库存
    useEffect(() => {
        // type 1: 按时间线划分两个阶段 2：按实时库存划分两个阶段 3: 只有一个常规售卖阶段
        // 正常是类型二才会实时请求库存（显示进度条），但是24年4月的类型3（wave2需求）也要求显示进度条 => 逻辑改为只要有count参数且不为0即同步请求实时库存
        if (bundlesData[0]?.type === 2 || bundlesData[0]?.count) {
            (async () => {
                const res = await getInitInventory(locale);
                if (res?.code === '0') {
                    updateBundles(res?.data);
                } else {
                    console.error(res?.message);
                }
            })();
        }
        if (bundlesData[0]?.type === 3) {
            const withShopifyPriceArr = syncShopifyPrice(bundlesData);
            setCurrList(withShopifyPriceArr);
        }
    }, []);

    useEffect(() => {
        // 按时间线划分阶段
        // 05/06 由于按库存划分阶段也可能存在倒计时， 修改判断条件 => 0513一直存在倒计时
        // if (bundlesData[0]?.type === 1 || bundlesData?.some((bundle: any) => bundle?.countdown)) {
        // 测试环境异常
        if (serverTimeStamp?.current < 1000000) {
            (async () => {
                const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                const headers: any = getDefaultHeader(locale);

                try {
                    const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                        headers,
                    });
                    const globalData = await spuData.json();
                    serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                } catch (e) {
                    console.log(e);
                }
            })();
        }
        bundlesData[0]?.type === 1 && hanldleData();
        HAS_COUNTDOWN && formatCountdownDate(serverTimeStamp.current);
        if (serverTimeStamp.current <= end + 1000) {
            timer.current = setInterval(() => {
                serverTimeStamp.current += 1000;
                // 众筹阶段
                if (
                    serverTimeStamp.current >= stage1 &&
                    ((end > stage2 && serverTimeStamp.current < end) || (end === stage2 && serverTimeStamp.current <= end + 1000))
                ) {
                    bundlesData[0]?.type === 1 && hanldleData();
                    HAS_COUNTDOWN && formatCountdownDate(serverTimeStamp.current);
                }
            }, 1000);
        } else {
            clearInterval(timer.current);
        }

        if (typeof window !== 'undefined') {
            // 监听切屏事件
            window.document.addEventListener('visibilitychange', onVisibleChange);
        }
        return () => {
            clearInterval(timer.current);
        };
        // }
    }, []);

    useEffect(() => {
        const { data } = receiver;
        if (data?.length > 0) {
            updateBundles(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [receiver]);

    useEffect(() => {
        if (activeTab !== 'bundles') {
            if (!bundlesData[0]?.ignore) {
                mqttUnsubscribe('inventory');
            }
        } else {
            mqttSubscribe('inventory');
        }
    }, [activeTab]);

    const getDataLayer = ({ product_name, price, tag, quantity, button_name }: any) => {
        return {
            event: 'uaEvent',
            list_name: 'none',
            event_name: 'bundle_price_guarantee',
            product_name,
            price,
            tag: tag || 'none',
            quantity,
            button_name,
        };
    };
    return (
        <div className={`bundles ${css.bundles}`}>
            <ul className="bundles-box">
                {currList?.map((bundle: any, k: number) => (
                    <li className={`bundle-item ${bundle?.countdown ? 'has-countdown-date' : ''}`} key={k}>
                        <div className="top-box">
                            <div className="title-wrapper">
                                <div className="tag-box">
                                    <div className={`bundle-tag ${bundle?.tag === 1 ? 'super' : !bundle?.tag ? 'hide' : ''}`}>
                                        {bundle?.tag === 1
                                            ? t.rich('crowdfunding.bundles.supper_early_tag', {
                                                  red: (text: string) => <span className="red">{text}</span>,
                                              })
                                            : bundle?.tag === 2
                                            ? t('crowdfunding.bundles.supper_tag')
                                            : bundle?.tag === 3
                                            ? t('crowdfunding.bundles.pre_order')
                                            : bundle?.tag === 4
                                            ? t('crowdfunding.bundles.new_arrival')
                                            : typeof bundle?.tag === 'string'
                                            ? bundle?.tag
                                            : t('crowdfunding.bundles.order')}
                                    </div>
                                    {locale === 'jp' && (bundle?.off || (bundle?.originalPrice - bundle?.discountPrice > 0 && !bundle?.off)) && (
                                        <span className="save-jp">
                                            {!bundle?.off && t('crowdfunding.bundles.save')}
                                            {bundle?.off ||
                                                ` ${!MONEY_SORT ? t('crowdfunding.bundles.unit') : ''} ${FormatMoney(
                                                    bundle?.originalPrice - bundle?.discountPrice,
                                                    MONEY_SPLITER,
                                                )} ${bundle?.price_suffix} ${MONEY_SORT ? t('crowdfunding.bundles.unit') : ''}`}
                                        </span>
                                    )}
                                </div>
                                {bundle?.name && (
                                    <p className={`bundle-title ${bundle?.link_more ? 'link' : ''}`} onClick={() => handleToShopify(bundle?.link_more)}>
                                        {bundle?.name}
                                    </p>
                                )}
                            </div>
                            {bundle?.img && (
                                <div className="bundle-img">
                                    {Array.isArray(bundle?.img) ? (
                                        <EFPic name={bundle?.img} className="fullImgs" alt={bundle?.title} aria-label={bundle?.title} />
                                    ) : (
                                        <Image
                                            src={bundle?.img}
                                            className="fullImgs"
                                            layout="fill"
                                            noUseSrcset={true}
                                            alt={bundle?.title}
                                            aria-label={bundle?.title}
                                        />
                                    )}
                                </div>
                            )}

                            <div className="bundle-info">
                                {bundle?.include?.length > 0 && (
                                    <div className={`includes ${bundle?.include?.length > 0 ? '' : 'hide'} ${bundle?.delivery_date ? '' : 'long'}`}>
                                        <p className="include-title">{t('crowdfunding.bundles.includes')}</p>
                                        <ul className="include-content">
                                            {bundle?.include?.map((include: any, m: number) => (
                                                <li
                                                    className={`include-item ${bundle?.hasNote && m === bundle?.include?.length - 1 ? 'note-tip' : ''}`}
                                                    key={`bundle_${k}_clude_${m}`}
                                                >
                                                    {include}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                {bundle?.delivery_date && (
                                    <div className={`delivery ${bundle?.include?.length > 0 ? '' : 'all'}`}>
                                        <p className="delivery-title">{t('crowdfunding.bundles.delivery')}</p>
                                        <p className="delivery-date">{bundle?.delivery_date}</p>
                                    </div>
                                )}
                                {bundle?.note && <div className="note">{bundle?.note}</div>}
                            </div>
                        </div>
                        <div className="bottom-box">
                            {/* 2023-05-06 galcier两个产品常规阶段卖不动，为促进消费，@陈琨要求添加日期倒计时 */}
                            {bundle?.countdown && (
                                <div className="bundle-countdown-date">
                                    <div className="ends-in">{t('crowdfunding.bundles.ends_in')}</div>
                                    <div className="date-box">
                                        {countdownDateObj?.d >= 0 && (
                                            <div className="days-box date-list">
                                                <span className="days date-number">{countdownDateObj?.d}</span>
                                                <span className="days-text date-text">
                                                    {countdownDateObj?.d === '01' ? t('crowdfunding.bundles.Day') : t('crowdfunding.bundles.Days')}
                                                </span>
                                            </div>
                                        )}
                                        {countdownDateObj?.h >= 0 && (
                                            <div className="hours-box date-list">
                                                <span className="hours date-number">{countdownDateObj?.h}</span>
                                                <span className="hours-text date-text">
                                                    {countdownDateObj?.h === '01' ? t('crowdfunding.bundles.Hour') : t('crowdfunding.bundles.Hours')}
                                                </span>
                                            </div>
                                        )}
                                        {countdownDateObj?.m >= 0 && (
                                            <div className="minutes-box date-list">
                                                <span className="minutes date-number">{countdownDateObj?.m}</span>
                                                <span className="minutes-text date-text">
                                                    {countdownDateObj?.m === '01' ? t('crowdfunding.bundles.Minute') : t('crowdfunding.bundles.Minutes')}
                                                </span>
                                            </div>
                                        )}
                                        {countdownDateObj?.s >= 0 && (
                                            <div className="seconds-box date-list">
                                                <span className="seconds date-number">{countdownDateObj?.s}</span>
                                                <span className="seconds-text date-text">
                                                    {countdownDateObj?.s === '01' ? t('crowdfunding.bundles.Second') : t('crowdfunding.bundles.Seconds')}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {/* 早鸟阶段售卖进度条 */}
                            {/* 0515 老板要求卖2000个wave-2, shopify那边也是真实2000个库存，但是为了促销，前端页面只能显示400个 @陈琨 */}
                            <div className={`bundle-countdown ${!bundle?.ignore && bundle?.count ? '' : 'hide'}`}>
                                <div className="countdown-number">
                                    <span className="total">
                                        {Number(bundle?.inventory) >= 0
                                            ? bundle?.count -
                                              (bundle?.realCount > 0
                                                  ? Math.ceil(Number(bundle?.inventory) / (Number(bundle?.realCount) / Number(bundle?.count)))
                                                  : Number(bundle?.inventory))
                                            : 0}{' '}
                                        {t('crowdfunding.bundles.backers')}
                                    </span>
                                    <span
                                        className={`rest ${
                                            (bundle?.realCount > 0
                                                ? Math.ceil(Number(bundle?.inventory) / (Number(bundle?.realCount) / Number(bundle?.count)))
                                                : Number(bundle?.inventory)) <= 10
                                                ? 'red'
                                                : ''
                                        }`}
                                    >
                                        {Math.max(
                                            bundle?.realCount > 0
                                                ? Math.ceil(bundle?.inventory / (Number(bundle?.realCount) / Number(bundle?.count)))
                                                : bundle?.inventory,
                                            0,
                                        )}{' '}
                                        {t('crowdfunding.bundles.rest')}
                                    </span>
                                </div>

                                <div className="progress-bar">
                                    <span
                                        className="red"
                                        style={{
                                            width: `${Math.min(
                                                bundle?.realCount > 0
                                                    ? (Math.floor(
                                                          (Number(bundle?.realCount) - Number(bundle?.inventory)) / (Number(bundle?.realCount) / bundle?.count),
                                                      ) *
                                                          100) /
                                                          Number(bundle?.count)
                                                    : ((Number(bundle?.count) - Number(bundle?.inventory)) * 100) / Number(bundle?.count),
                                                100,
                                            )}%`,
                                        }}
                                    ></span>
                                </div>
                            </div>
                            <div className="bundle-price-buy">
                                <div className="price-box">
                                    <div className="price-varity">
                                        <span className="discount">
                                            {!MONEY_SORT ? t('crowdfunding.bundles.unit') : ''}
                                            {FormatMoney(bundle?.discountPrice, MONEY_SPLITER)} <span className="price-suffix">{bundle?.price_suffix}</span>
                                            {MONEY_SORT ? t('crowdfunding.bundles.unit') : ''}
                                        </span>
                                        {bundle?.discountPrice !== bundle?.originalPrice && (
                                            <span className="original">
                                                {!MONEY_SORT ? t('crowdfunding.bundles.unit') : ''}
                                                {FormatMoney(bundle?.originalPrice, MONEY_SPLITER)} <span className="price-suffix">{bundle?.price_suffix}</span>
                                                {MONEY_SORT ? t('crowdfunding.bundles.unit') : ''}
                                            </span>
                                        )}
                                    </div>
                                    {(bundle?.discountPrice !== bundle?.originalPrice || bundle?.off) && (
                                        <div className={`save ${bundle?.stage === 2 && bundle?.originalPrice === bundle?.discountPrice ? 'no' : ''}`}>
                                            {locale !== 'jp' && t('crowdfunding.bundles.save')}{' '}
                                            {locale !== 'jp' &&
                                                (bundle?.off ||
                                                    `${`${!MONEY_SORT ? t('crowdfunding.bundles.unit') : ''} ${FormatMoney(
                                                        bundle?.originalPrice - bundle?.discountPrice,
                                                        MONEY_SPLITER,
                                                    )} ${MONEY_SORT ? t('crowdfunding.bundles.unit') : ''}`} ${bundle?.price_suffix}`)}{' '}
                                            {locale === 'jp' && bundle?.stage === 1 && (
                                                <Link
                                                    className="guarantee"
                                                    href="https://jp.ecoflow.com/pages/price-guarantee"
                                                    dataLayer={getDataLayer({
                                                        product_name: bundle.name,
                                                        price: bundle.discountPrice,
                                                        tag:
                                                            bundle.tag === 1
                                                                ? t('crowdfunding.bundles.supper_early')
                                                                : bundle.tag === 2
                                                                ? t('crowdfunding.bundles.supper_tag')
                                                                : bundle.tag === 3
                                                                ? t('crowdfunding.bundles.pre_order')
                                                                : bundle.tag === 4
                                                                ? t('crowdfunding.bundles.new_arrival')
                                                                : typeof bundle?.tag === 'string'
                                                                ? bundle?.tag
                                                                : t('crowdfunding.bundles.order'),
                                                        quantity: 1,
                                                        button_name: '6ヶ月価格保証対象',
                                                    })}
                                                >
                                                    6ヶ月価格保証対象
                                                </Link>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="buy-btn-box">
                                    {bundle?.inventory <= 0 && !bundle?.ignore && (
                                        <button disabled={bundle?.rest <= 0} className="buy sold-out">
                                            {t('crowdfunding.bundles.sold_out')}
                                        </button>
                                    )}
                                    {bundle?.inventory > 0 && !bundle.node && !bundle?.ignore && (
                                        <Link
                                            target="_blank"
                                            href={bundle?.buyLink}
                                            key={bundle?.index}
                                            ariaLabel={t('crowdfunding.bundles.buy')}
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'checkout',
                                                button_name: `${t('crowdfunding.bundles.buy')}_${bundle.name}`,
                                            }}
                                        >
                                            <div className="buy">{t('crowdfunding.bundles.buy')}</div>
                                        </Link>
                                    )}
                                    {(bundle?.inventory > 0 || bundle?.ignore) && bundle?.node && (
                                        // <div className="buy-btn-wrapper">
                                        //     <ShopifyBuyBtn
                                        //         key={bundle?.variantId}
                                        //         productId={bundle?.id}
                                        //         variantId={bundle?.variantId}
                                        //         node={bundle?.node}
                                        //         activeTab={activeTab}
                                        //         text={{
                                        //             buy: bundle?.buy_btn || t('crowdfunding.bundles.buy'),
                                        //             soldout: t('crowdfunding.bundles.sold_out'),
                                        //         }}
                                        //         data={{
                                        //             productName: bundle.name,
                                        //             price: bundle.discountPrice,
                                        //             tag:
                                        //                 bundle.tag === 1
                                        //                     ? t('crowdfunding.bundles.supper_early')
                                        //                     : bundle.tag === 2
                                        //                     ? t('crowdfunding.bundles.supper_tag')
                                        //                     : bundle.tag === 3
                                        //                     ? t('crowdfunding.bundles.pre_order')
                                        //                     : bundle.tag === 4
                                        //                     ? t('crowdfunding.bundles.new_arrival')
                                        //                     : typeof bundle?.tag === 'string'
                                        //                     ? bundle?.tag
                                        //                     : t('crowdfunding.bundles.order'),
                                        //             quantity: 1,
                                        //             button_name: t('crowdfunding.bundles.buy'),
                                        //             bundleList: currList,
                                        //         }}
                                        //         shopifyBtnProps={shopifyBtnProps}
                                        //     />
                                        // </div>
                                        // 2024-04-18 kunkun要求直接checkout，不需要拉起购物车 wave2早鸟bundle需求开始
                                        <Link
                                            target="_blank"
                                            href={`https://${locale}.ecoflow.com/cart/${bundle.variantId}:1?channel=buy_button`}
                                            key={bundle?.index}
                                            ariaLabel={t('crowdfunding.bundles.buy')}
                                            // dataLayer={{
                                            //     event: 'uaEvent',
                                            //     event_name: 'checkout',
                                            //     button_name: `${t('crowdfunding.bundles.buy')}_${bundle.name}`,
                                            // }}
                                            onClick={() => handleLinkClick(bundle)}
                                        >
                                            <div className="buy">{t('crowdfunding.bundles.buy')}</div>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const ChildMemo = memo(Child);
export default function Bundles({
    bundlesData,
    activeTab,
    nowSysTime,
    crowdfundingTimeline,
    shopifyBtnProps,
    activityId,
    callbackSubtitle,
    callbackDays,
    days,
    topCountdown,
    callbackCountdown,
    getShopifyPrice,
}: any) {
    return (
        <ChildMemo
            bundlesData={bundlesData}
            days={days}
            activeTab={activeTab}
            nowSysTime={nowSysTime}
            crowdfundingTimeline={crowdfundingTimeline}
            shopifyBtnProps={shopifyBtnProps}
            activityId={activityId}
            callbackSubtitle={callbackSubtitle}
            callbackDays={callbackDays}
            topCountdown={topCountdown}
            callbackCountdown={callbackCountdown}
            getShopifyPrice={getShopifyPrice}
        />
    );
}
